@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.root {
  display: flex;
  flex-direction: column;

  @include for-desktop-only {
    padding-bottom: 20px;
  }
}
